<template>
     <!-- Experience Modal -->
  <v-dialog v-model="modalDialog" max-width="525px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Skills Required Informations</h5>
        <button type="button" class="close" @click="method()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
          <div>
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                                        <table class="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Skill</th>
                                                    <th>Required Grade</th>
                                                    <th>Applicant Grade</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in model" v-bind:key="item.id">
                                                    <td>{{item.jobSkillLevel.skill.name}}</td>
                                                    <td>{{item.jobSkillLevel.skillGrade.name}}</td>
                                                    <td>{{item.skillGrade.name}}</td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </v-dialog>
  <!-- /Experience Modal -->
</template>
<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { applicantService } from "@/services/applicantService";
import Datepicker from "vuejs-datepicker";
export default {
  props: {
    model: {},
    grades: {},
    id: 0,
    skillId: 0,
    dialog: Boolean,
    method: { type: Function },
  },

  components: {
    Datepicker,
  },

  data() {
    return {
      modalDialog: this.dialog,
      applicationId: this.id,
      applicationSkills: [],
      item: {},
      gradeId: 0,
      viewSkill: this.skillId ? this.skillId : 0,
      complete: false,
      error: "",
      message: "",
      submitted: false,
    };
  },

  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/applications/SkillModal.vue